@import 'spinners';

body.lightbox-open {
	overflow: hidden;
}

.video-embed {

	.img {
		width: 100%;
		height: 500px;
		background-size: cover;
		background-position: center;
		position: relative;
		z-index: 1;
	}

	button {
		position: relative;
		width: 100%;
		border: none;
		outline: none;
		background: none;
		padding: 0;

		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			opacity: 0;
			z-index: 2;
			background: $basic_cta_hover_overlay;
			transition: opacity .3s ease-in-out;
		}
		&:hover, &:focus { 

			&::after {
				opacity: .3; 
			}
			.play-icon { transform: translate(-50%, -50%) scale(1.2); }
		}		
	}
	img {
		max-width: 100%;
		margin: 0 auto;
	}
	.play-icon {
		position: absolute;
		z-index: 3;
		top: 50%;
		max-height: 165px;
		max-width: 165px;
		left: 50%;
		transform: translate(-50%, -50%);		
		@include transitionFast(filter);
		transition: transform .3s ease-in-out;
	}
	.yt-play {
		max-width: 29px;
		max-height: 35px;		
	}	
}

.video-embed-content {
	display: none;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
	z-index: 100;

	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,.5);
		opacity: 0;
		transition: opacity 400ms;
	}

	&.open {
		display: flex;

		.overlay {
			opacity: 1;
		}
	}

	.video-inner {
		position: relative;

		.modal-spinner {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		.video-frame {
			position: relative;
			z-index: 2;

			& > div {
				text-align: right;
				margin-bottom: 5px;
			}
		}

		@media screen and (max-width: 1020px) {
			width: 95%;
			margin: 0 auto;

			iframe {
				width: 100%;
			}
		}
	}

	.close-frame {
		width: 30px;
		height: 30px;
		color: $white;
		padding: 0;
		@include transitionDefault(all);

		svg {
			@include svg-format(30px, 30px, #fff);
		}

		&:hover {
			opacity: .85;
		}

		@include focus-visible-box-shadow(0 0 0 2px rgba($white, .75));

		&.close-frame-bottom {
			width: auto;
		}
	}

}
